import { useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { createProfile } from '../../services/apiService';
import { useNavigate } from 'react-router-dom';
import styles from './CreateProfileModal.module.css';

const CreateProfileModal = ({ onClose, onSave }) => {
  const navigate = useNavigate();
  const { getAccessTokenSilently } = useAuth0();
  const [profileName, setProfileName] = useState('');
  const [username, setUsername] = useState('');
  const [summary, setSummary] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async () => {
    if (!profileName || !username || !summary) {
      setError('All fields are required.');
      return;
    }

    setIsSaving(true);
    setError(null);

    try {
      const accessToken = await getAccessTokenSilently();
      const payload = { profileName, username, summary };
      const newProfile = await createProfile(payload, accessToken);
      onSave();
      onClose();
      navigate(`/profiles/edit/${newProfile.profileId}`);
    } catch (err) {
      setError('Failed to create profile. The username might be taken.');
      console.error(err);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={() => onClose()}>
          &times;
        </button>
        <h3>Create a New Profile of Me</h3>
        <p className={styles.description}>
          This creates a new public-facing "hat" that inherits its core
          personality from your Digital Passport. You only need to define what's
          different.
        </p>

        <div className={styles.formGroup}>
          <label htmlFor="profileName">Profile Name</label>
          <input
            type="text"
            id="profileName"
            value={profileName}
            onChange={(e) => setProfileName(e.target.value)}
            placeholder="e.g., My Professional Profile"
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="username">Public Username (for URL)</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value.toLowerCase().trim())}
            placeholder="e.g., your-name-pro"
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="summary">Custom Summary</label>
          <textarea
            id="summary"
            rows="4"
            value={summary}
            onChange={(e) => setSummary(e.target.value)}
            placeholder="A new summary tailored for this profile's specific audience."
          />
        </div>

        {error && <p className="errorText">{error}</p>}

        <div className={styles.modalActions}>
          <button
            onClick={onClose}
            className="action-button secondary"
            disabled={isSaving}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="action-button primary"
            disabled={isSaving}
          >
            {isSaving ? 'Creating...' : 'Create Profile'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateProfileModal;
